

<!-- Confirm Validate(START) -->
<kpmg-dialog #mdlSession [headingTemplate]="mdlSessionHeading" [bodyTemplate]="mdlSessionBody" [footerTemplate]="mdlSessionFooter"></kpmg-dialog>
<ng-template #mdlSessionHeading>
  <h4>Session Timing Out!</h4>
</ng-template>
<ng-template #mdlSessionBody>
  <div class="form-group text-center m-0 mt-2">
    <h2 class="text-center"><i class="fas fa-hourglass-half pr-2"></i> Your session will expire in</h2>
    <div class="text-center h1">
      {{minutes}}:{{counter| number : '2.0-0'}}s
    </div>
  </div>
</ng-template>
<ng-template #mdlSessionFooter>
  <button class="btn btn-success" type="submit" (click)='continueSession()'>Continue Session</button>
  <input type="button" id="btnClientClose" class="btn btn-cancel" (click)='logOut()' value="LogOut" />
</ng-template>
<!-- Confirm Validate (END) -->